import Lottie from "lottie-react";
import { Box, Typography } from "@mui/material";
import comingSoonAnimation from "./Coming Soon GIF.json"; // put JSON in src folder

const ComingSoon = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // vertical center
        alignItems: "center",     // horizontal center
        textAlign: "center",
        minHeight: "100%",       // full viewport height
        p: 4
      }}
    >
      <Typography variant="h3" sx={{ mb: 2 }}>
        This will be available shortly
      </Typography>
      <Lottie animationData={comingSoonAnimation} loop={true} />
    </Box>
  );
};

export default ComingSoon;
